import React, { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { ShopContext } from '../context/shopcontext';
import Title from './Title';
import ProductItem from './ProductItem';

const RelatedProducts = ({ category, subCategory, currentProductId }) => {
  const { backendUrl } = useContext(ShopContext);
  const [related, setRelated] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchRelated = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(`${backendUrl}/api/product/list`, {
          params: {
            page: 1,
            limit: 10,
            category,
            subCategory,
            sortField: 'date',
            sortOrder: -1,
          },
        });

        if (res.data.success) {
          // Exclude the current product
          const filtered = res.data.products.filter((item) => item._id !== currentProductId);
          setRelated(filtered);
        }
      } catch (err) {
        console.error('Failed to fetch related products', err);
      } finally {
        setIsLoading(false);
      }
    };

    if (category && subCategory && currentProductId) {
      fetchRelated();
    }
  }, [category, subCategory, backendUrl, currentProductId]);

  // If loading or no related products, don't render the section
  if (isLoading || related.length === 0) {
    return null;
  }

  return (
    <div className="my-8">
      {/* Title */}
      <div className="text-center text-xl py-2">
        <Title text1={'You may '} text2={'also like'} />
      </div>

      {/* Horizontal Scroll */}
      <div className="overflow-x-auto">
        <div className={`flex gap-4 ${related.length === 1 ? 'justify-center' : ''}`}>
          {related.map((item) => (
            <div key={item._id} className="flex-shrink-0 w-40 sm:w-48 md:w-56 lg:w-64">
              <ProductItem
                id={item._id}
                price={item.price}
                image={item.image}
                name={item.name}
                rating={item.averageRating || 0}
                totalReviews={item.totalReviews}
                bestseller={item.bestseller}
                inStock={item.inStock}
                category={item.category}
                subCategory={item.subCategory}
                currentPage={1}
                categoryFilter={[]}
                subCategoryFilter={[]}
                sortType={'relevant'}
                fromRelated={true}
              />

              {/* Add color below product */}
            </div>
          ))}
        </div>
      </div>
      <hr />
    </div>
  );
};

export default RelatedProducts;
